
import { mapGetters, mapState, mapActions } from "vuex";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import { store } from "../../storeNfe";
import ImpostosData from "../ImpostosData";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import _ from "lodash";
import { mask } from "vue-the-mask";

export default {
  name: "app-nfe-form-impostosTab",
  components: {
    Money,
  },
  directives: {
    mask,
  },
  data() {
    return {
      store,
      loading: false,
      form: null,
      windowWidth: window.innerWidth,
      total: 0,
      configMask: settingMoney,
    };
  },
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin],
  methods: {
    ...mapActions(["setLoading"]),
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    requestCalcImpostos() {
      this.loading = true;
      this.calcImposto(this);
    },
    calcImposto: _.debounce(async (vm) => {
      if (vm.store.currentTab === 3) vm.$toast.info("Calculando NFe...");
      vm.dataSendToApi = vm.formatDataToSendToApi(
        vm.store.formNatureza,
        vm.store.formProduto,
        vm.store.formCliente,
        vm.store.formFaturamento.pagamentos.length === 0
          ? null
          : vm.store.formFaturamento,
        vm.form
      );
      const { dados } = await vm.getTotaisNfe(vm.dataSendToApi);
      vm.store.formImpostos = {
        ...vm.store.formImpostos,
        ...dados.total,
      };
      vm.$toast.success("Totais da NFe atualizados!");
      vm.loading = false;
    }, 1000),
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  created() {
    if (Object.keys(this.$route.params).length !== 0) {
      this.store.formImpostos = new ImpostosData({});
      this.form = this.store.formImpostos;
      const {
        baseICMS,
        valorICMS,
        baseICMSST,
        valorICMSST,
        valorIPI,
        vFCPST,
        totalProd,
        ICMSdesoneracao,
        totalNFE,
        freightPrice,
        insurance,
        extraValue,
        discount,
      } = this.$route.params.nfeData;

      this.store.formImpostos = {
        baseICMS,
        valorICMS,
        baseICMSST,
        valorICMSST,
        valorIPI,
        vFCPST,
        totalProd,
        ICMSdesoneracao,
        totalNFE,
        freightPrice,
        insurance,
        extraValue,
        discount,
      };
      this.total = totalNFE;
    } else {
      this.store.formImpostos = new ImpostosData({});
    }
  },
  watch: {
    "store.formImpostos"(newValue, oldValue) {
      if (newValue !== oldValue) this.form = newValue;
    },
    "store.formImpostos.totalNFE"(newValue, oldValue) {
      if (newValue !== oldValue) this.total = newValue;
    },
    "store.formImpostos.freightPrice"(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.total =
          this.store.formImpostos.totalProd +
          newValue +
          this.store.formImpostos.extraValue +
          this.store.formImpostos.insurance -
          this.store.formImpostos.discount;
        this.requestCalcImpostos();
      }
    },
    "store.formImpostos.discount"(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.total =
          this.store.formImpostos.totalProd +
          this.store.formImpostos.freightPrice +
          this.store.formImpostos.extraValue +
          this.store.formImpostos.insurance -
          newValue;
        this.requestCalcImpostos();
      }
    },
    "store.formImpostos.extraValue"(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.total =
          this.store.formImpostos.totalProd +
          this.store.formImpostos.freightPrice +
          newValue +
          this.store.formImpostos.insurance -
          this.store.formImpostos.discount;
        this.requestCalcImpostos();
      }
    },
    "store.formImpostos.insurance"(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.total =
          this.store.formImpostos.totalProd +
          this.store.formImpostos.freightPrice +
          this.store.formImpostos.extraValue +
          newValue -
          this.store.formImpostos.discount;
        this.requestCalcImpostos();
      }
    },
    "store.currentTab"(newValue, oldValue) {
      if (Object.keys(this.$route.params).length !== 0) return;
      if (newValue > oldValue && newValue > 3) {
        this.store.formImpostos.totalProd = this.total;
      }
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    isTheCurrentTab() {
      return store.currentTab === 3;
    },
  },
};
